import React from 'react';
import './PowerSection.css';

const PowerSection: React.FC = () => {
  return (
    <section id="power" className="power-section">
      <div className="power-container">
        <div className="power-header">
          <h2 className="power-title">Power Your Telephony Across India</h2>
          <p className="power-description">
            Build, deploy, and scale telephony solutions across India with our carrier-agnostic platform. 
            Connect agents anywhere, integrate with any AI provider, and stay compliant with Indian regulations.
          </p>
        </div>
        
        <div className="power-features">
          <div className="feature-card">
            <div className="feature-icon">
              <img src="https://assets.taar.ai/carriers.png" alt="Carrier Agnostic" className="power-icon" />
            </div>
            <h3 className="feature-title">Carrier Agnostic</h3>
            <p className="feature-description">
              Partner directly with any telecom provider in India. No need for local offices or complex partnerships.
            </p>
          </div>
          
          <div className="feature-card">
            <div className="feature-icon">
              <img src="https://assets.taar.ai/ai.png" alt="AI Integration" className="power-icon" />
            </div>
            <h3 className="feature-title">AI Integration</h3>
            <p className="feature-description">
              Integrate with any AI provider for intelligent call routing, sentiment analysis, and automated responses.
            </p>
          </div>
          
          <div className="feature-card">
            <div className="feature-icon">
              <img src="https://assets.taar.ai/compliance.png" alt="Compliance Ready" className="power-icon" />
            </div>
            <h3 className="feature-title">Compliance Ready</h3>
            <p className="feature-description">
              Built-in TRAI & DoT compliance. Full regulatory adherence without additional setup or configuration.
            </p>
          </div>
          
          <div className="feature-card">
            <div className="feature-icon">
              <img src="https://assets.taar.ai/national.png" alt="Global Scale" className="power-icon" />
            </div>
            <h3 className="feature-title">Global Scale</h3>
            <p className="feature-description">
              Scale from 5 to 50,000 agents without rigid slabs or hidden commitments. Deploy anywhere in India.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PowerSection;
